// extracted by css-extract-rspack-plugin
export default {"maskPopover":"PurchasePricePopover_maskPopover__VGU0R","divider":"PurchasePricePopover_divider__pyO57"};